// BookyaraLogo — renders as React component, no font-loading dependency
// size: "sm" (navbar), "md" (login/signup), "lg" (marketing hero)
// variant: "full" (icon + wordmark), "icon" (square icon only)
export default function BookyaraLogo({ size = "sm", variant = "full", className = "" }) {
  const iconSizes = { sm: 36, md: 48, lg: 56 };
  const textSizes = { sm: "text-xl", md: "text-2xl", lg: "text-3xl" };
  const px = iconSizes[size];

  return (
    <div className={`inline-flex items-center gap-2.5 ${className}`}>
      {/* Icon square */}
      <div
        style={{ width: px, height: px, borderRadius: px * 0.22, flexShrink: 0, position: "relative", background: "#0F6E56" }}
      >
        {/* B */}
        <span style={{
          position: "absolute", left: "8%", bottom: "8%",
          fontFamily: "Georgia, 'Times New Roman', serif",
          fontSize: px * 0.68, fontWeight: 700, color: "white", lineHeight: 1,
          userSelect: "none",
        }}>B</span>
        {/* y */}
        <span style={{
          position: "absolute", left: "46%", bottom: "6%",
          fontFamily: "Georgia, 'Times New Roman', serif",
          fontSize: px * 0.62, fontWeight: 400, color: "#5DCAA5", lineHeight: 1,
          userSelect: "none",
        }}>y</span>
        {/* Gold dot */}
        <span style={{
          position: "absolute", top: "10%", right: "10%",
          width: px * 0.17, height: px * 0.17,
          borderRadius: "50%", background: "#F5A623", display: "block",
        }} />
      </div>

      {/* Wordmark */}
      {variant === "full" && (
        <span className={`${textSizes[size]} font-semibold tracking-tight`} style={{ color: "#0F6E56", fontWeight: 700 }}>
          Bookyara
        </span>
      )}
    </div>
  );
}
